/* CDN PDP gallery: mobile swipe dots + COLOUR-FILTERED gallery. PDP-only, no deps.
   - CSS (cdn-home.css) turns the stacked image-layers gallery into a horizontal
     scroll-snap carousel at <=899px; this adds the page dots + active sync.
   - On colour select, shows ONLY the selected colour's photos (all angles) and
     rebuilds the dots. Shopify only ties the FRONT image to each colour variant,
     so other angles are matched by the colour token in the image filename, using
     the selected variant's own front-image as the 'stem' (e.g. classic-snapback-
     black) + an angle-aware regex so 'Navy' never grabs 'Dark Navy'/'Navy/ Red'.
   - FAIL-SAFE: if a product's filenames don't match the pattern (no matches), it
     shows everything — nothing is ever wrongly hidden.
   Mobile filters the main carousel; desktop filters the thumbnail rail (main stays
   theme-controlled). */
(function () {
  var ANGLES = 'front|back|left-side|right-side|left-front|right-front|top|detail|flat';

  function fnameOf(url) { if (!url) return ''; return url.split('?')[0].split('/').pop().toLowerCase(); }
  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function imgUrl(img) { return img.getAttribute('src') || img.getAttribute('data-src') || ''; }

  function getProduct() {
    try {
      var s = document.querySelector('#productTop [data-product-json]') ||
              document.querySelector('[data-product-form] script[data-product-json]');
      return s ? JSON.parse(s.textContent) : null;
    } catch (e) { return null; }
  }

  function colourIndex(product) {
    if (!product || !product.options) return 0;
    for (var i = 0; i < product.options.length; i++) {
      if (/colou?r/i.test(product.options[i])) return i + 1;
    }
    return 0;
  }

  function selectedColourValue() {
    var groups = document.querySelectorAll('#productTop .single-option-radio[data-option]');
    for (var i = 0; i < groups.length; i++) {
      var r = groups[i].querySelector('input[type="radio"]');
      if (r && /colou?r/i.test(r.name)) {
        var c = groups[i].querySelector('input:checked');
        return c ? c.value : null;
      }
    }
    return null;
  }

  function selectedVariant(product) {
    if (!product) return null;
    var ci = colourIndex(product); if (!ci) return null;
    var val = selectedColourValue(); if (val == null) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i]['option' + ci] === val) return product.variants[i];
    }
    return null;
  }

  function currentStem(product) {
    var v = selectedVariant(product);
    if (!v || !v.featured_image || !v.featured_image.src) return null;
    var fn = fnameOf(v.featured_image.src);
    var stem = fn.replace(new RegExp('-(?:' + ANGLES + ')-[a-z0-9]+\\.(?:jpe?g|png|webp)$', 'i'), '');
    return stem === fn ? null : stem; // null if no angle suffix found (unknown pattern)
  }

  function currentImageId(product) {
    var v = selectedVariant(product);
    return v && v.featured_image ? v.featured_image.id : null;
  }

  function matches(url, stem) {
    return new RegExp('^' + esc(stem) + '-(?:' + ANGLES + ')(?:[-_.])', 'i').test(fnameOf(url));
  }

  function buildDots(col, track) {
    var old = col.querySelector('.cdn-gallery-dots');
    if (old) old.parentNode.removeChild(old);
    var slides = track.querySelectorAll(':scope > img.productImage');
    var visible = [];
    Array.prototype.forEach.call(slides, function (s) {
      if (s.style.getPropertyValue('display') !== 'none') visible.push(s);
    });
    if (visible.length < 2) return;

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'cdn-gallery-dots';
    dotsWrap.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < visible.length; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'cdn-gallery-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
      (function (idx) {
        dot.addEventListener('click', function () {
          track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
        });
      })(i);
      dotsWrap.appendChild(dot);
    }
    var imgBlock = track.closest('.eightNinth') || track.parentNode;
    if (imgBlock && imgBlock.parentNode) imgBlock.parentNode.insertBefore(dotsWrap, imgBlock.nextSibling);
    else col.appendChild(dotsWrap);
  }

  function filter(col, track) {
    var slides = track.querySelectorAll(':scope > img.productImage');
    if (slides.length < 2) return;
    var product = getProduct();
    var stem = currentStem(product);
    var isMobile = window.innerWidth <= 899;
    var activeId = currentImageId(product);

    var useFilter = !!stem;
    if (useFilter) {
      var any = false;
      Array.prototype.forEach.call(slides, function (s) { if (matches(imgUrl(s), stem)) any = true; });
      if (!any) useFilter = false; // fail-safe: unknown naming -> show all
    }

    Array.prototype.forEach.call(slides, function (s) {
      var m = useFilter ? matches(imgUrl(s), stem) : true;
      if (isMobile) {
        if (m) { s.style.removeProperty('display'); s.removeAttribute('data-cdn-hidden'); }
        else { s.style.setProperty('display', 'none', 'important'); s.setAttribute('data-cdn-hidden', '1'); }
      } else {
        // Desktop: keep the theme's single-image view. Only re-assert it if we
        // need to clear leftover mobile hides; never force-show (avoids overlap).
        s.removeAttribute('data-cdn-hidden');
        if (activeId != null) {
          if (String(s.getAttribute('data-image-id')) === String(activeId)) s.style.setProperty('display', 'block');
          else s.style.setProperty('display', 'none'); // non-important: theme thumb-click can still show it
        }
      }
    });

    // Thumbnail rail (used on desktop; hidden on mobile via CSS) — filter on both.
    var thumbs = document.querySelectorAll('#productTop .productThumbs li');
    Array.prototype.forEach.call(thumbs, function (li) {
      if (!useFilter) { li.style.removeProperty('display'); return; }
      var im = li.querySelector('img');
      var a = li.querySelector('a');
      var u = (im && imgUrl(im)) || (a && a.getAttribute('href')) || '';
      if (matches(u, stem)) li.style.removeProperty('display');
      else li.style.setProperty('display', 'none', 'important');
    });

    buildDots(col, track);
    if (isMobile) { try { track.scrollTo({ left: 0 }); } catch (e) { track.scrollLeft = 0; } }
  }

  function init() {
    var col = document.querySelector('#productTop .productImages');
    if (!col) return;
    var track = col.querySelector('.image-container');
    if (!track) return;
    if (track.querySelectorAll(':scope > img.productImage').length < 2) return;

    // Active-dot sync on scroll (reads current dots each time).
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var dots = col.querySelectorAll('.cdn-gallery-dot');
        if (!dots.length) return;
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        if (idx < 0) idx = 0; if (idx > dots.length - 1) idx = dots.length - 1;
        for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-active', j === idx);
      });
    }, { passive: true });

    var scheduled = false;
    function refilter() {
      if (scheduled) return; scheduled = true;
      requestAnimationFrame(function () { scheduled = false; filter(col, track); });
    }

    // Re-filter when a COLOUR radio changes (swatch click bubbles a native change).
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.tagName === 'INPUT' && t.type === 'radio' && /colou?r/i.test(t.name || '')) refilter();
    });
    window.addEventListener('resize', refilter, { passive: true });

    // Initial pass once the colour radios + product JSON are present.
    var tries = 0;
    (function wait() {
      if (getProduct() && document.querySelector('#productTop .single-option-radio input[type="radio"]')) {
        filter(col, track);
        // one more shortly after, to settle the theme's programmatic init-select
        setTimeout(function () { filter(col, track); }, 250);
        return;
      }
      if (tries++ < 40) setTimeout(wait, 80);
    })();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
